export const NOTIFY_TYPES = {
  success: 'success',
  error: 'error',
  info: 'info',
  warning: 'warning',
};

export const NOTIFY_DEFAULTS = {
  buttonText: 'common.ok',
  type: NOTIFY_TYPES.info,
  title: '',
  message: '',
};